import React from 'react';
import PropTypes from 'prop-types';

var SvgContextMixin = require('./svgContextMixin');

var SvgChartPoint = React.createClass({
  mixins: [SvgContextMixin],

  statics: {
    pointScaleRate: 1.3
  },

  propTypes: {
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    size: PropTypes.number,
    color: PropTypes.string
  },

  getInitialState(){
    return {
      isActive: false
    }
  },

  getDefaultProps(){
    return {
      size: 1,
      fill: "#000000"
    };
  },

  render(){
    var {x, y, size, color} = this.props;

    var pointSize = this.state.isActive
      ? SvgChartPoint.pointScaleRate * size
      : size;

    return (
      <circle
        cx={x} cy={y}
        r={pointSize}
        fill={color}
        cursor="pointer"
        onMouseEnter={this._onMouseIn}
        onClick={this.props.onMouseEnter}
        onMouseLeave={this._onMouseOut}
      />
    );
  },

  _onMouseIn(event){

    var {onMouseEnter} = this.props;

    if (onMouseEnter) {
      onMouseEnter(event);
    }

    this.setState({isActive: true});
  },

  _onMouseOut(event){
    var {onMouseLeave} = this.props;
    this.setState({isActive: false});
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  }

});


module.exports = SvgChartPoint;
